import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export interface IlinkListItem {
    link?: string;
    label: string;
    image?: string;
}

export const linkListItem = { link: '', label: 'Default link item label', image: '' };
@Component({
    selector: 'link-list1',
    templateUrl: './link-list1.html',
    styleUrls: ['./link-list1.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LinkList1Component {
    /**
     * Section title
     */
    @Input()
    title?: string;

    /**
     * Links list
     */
    @Input()
    items: IlinkListItem[] = [linkListItem];
}
